import { getEndpoint } from "../utils/stringUtil";
import client from "./axios";

export interface Conversation {
  id: number;
  participant1Id: number;
  participant2Id: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface ChatMessage {
  id: number;
  conversationId: number;
  senderId: number;
  text: string;
  read: boolean;
  createdAt?: string;
  updatedAt?: string;
}

const base = getEndpoint();

export const Chat = {
  // Conversations
  getMyConversations: (userId: number) =>
    client.get<{ list: Conversation[] }>(`${base}api/conversations/user/${userId}`),
  createConversation: (participant1Id: number, participant2Id: number) =>
    client.post<{ conversation: Conversation }>(`${base}api/conversations/create`, {
      participant1Id,
      participant2Id,
    }),
  deleteConversation: (id: number) =>
    client.delete(`${base}api/conversations/${id}`),

  // Messages
  getMessages: (conversationId: number) =>
    client.get<{ list: ChatMessage[] }>(`${base}api/chats/conversation/${conversationId}`),
  sendMessage: (conversationId: number, senderId: number, text: string) =>
    client.post<{ chat: ChatMessage }>(`${base}api/chats/create`, {
      conversationId,
      senderId,
      text,
    }),
  markMessageRead: (id: number) =>
    client.put(`${base}api/chats/${id}/read`, {}),
  markConversationRead: (conversationId: number) =>
    client.put<{ unread: number }>(`${base}api/conversations/${conversationId}/read`, {}),

  // Unread badge
  getUnread: (userId: number) =>
    client.get<{ unread: number }>(`${base}api/chats/unread/${userId}`),
};
